<template>
    <div id="error_view">

        <sct-header/>

        <section class="contenidoError">
            <h1 class="contenidoError__titulo">Error</h1>
            <p> La URL a la que intentas acceder no existe. </p>
            <router-link to="/e-recibos/">
                Volver a la página de anterior
            </router-link>
        </section>

        <sct-footer/>

    </div>
</template>

<script>

import SctFooter from "@/components/template/SctFooter"
import SctHeader from "@/components/template/SctHeader"

export default {

    name:'Error',
    components: {
        SctFooter,
        SctHeader
    }
}
</script>